<template>
  <div class="card">
    <div class="card-body">
      <a-page-header
        :title="$t('xlsxUploader.importEleves')"
        :sub-title="$t('xlsxUploader.importElevesSubTitle')"
      >
        <template slot="tags">
          <a-tag color="blue"> Excel </a-tag>
        </template>

        <template slot="extra">
          <a-button type="primary" @click="download">
            <a-icon type="file-excel" @click="download" />
            {{ $t("xlsxUploader.downloadTemplate") }}
          </a-button>
        </template>
      </a-page-header>
      <div class="row">
        <div class="col-md-9">
          <a-upload-dragger
            :multiple="false"
            :before-upload="beforeUpload"
            :file-list="fileList"
            :customRequest="addTofileList"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="file-excel" />
            </p>
            <p class="ant-upload-text">
              {{ $t("xlsxUploader.cliquer") }}
            </p>
          </a-upload-dragger>
        </div>
        <div class="col-md-3 p-3 mb-2 bg-light bg-gradient">
          <a-steps direction="vertical" size="small" :current="step">
            <a-step
              :title="$t('xlsxUploader.importEleves')"
              :description="$t('xlsxUploader.importElevesSubTitle')"
            />
            <a-step
              :title="$t('xlsxUploader.affectation')"
              :description="$t('xlsxUploader.affectationSubTitle')"
            />
            <a-step
              :title="$t('xlsxUploader.enregistrer')"
              :description="$t('xlsxUploader.enregistrerSubTitle')"
            />
          </a-steps>
        </div>

        <div class="col-md-12 mt-2" v-if="showStudentErrors">
          <a-alert
            type="error"
            :message="$t('xlsxUploader.erreurValidationEleves')"
            :description="studentErrorDescription"
            banner
            show-icon
            closable
            @close="showStudentErrors = false"
          />
        </div>

        <div class="col-md-12 mt-2" v-if="showParentErrors">
          <a-alert
            type="error"
            :message="$t('xlsxUploader.erreurValidationParents')"
            :description="parentErrorDescription"
            banner
            show-icon
            closable
            @close="showParentErrors = false"
          />
        </div>

        <div class="col-md-12 mt-2" v-if="showDateErrors">
          <a-alert
            type="error"
            :message="$t('xlsxUploader.erreurFormatDate')"
            :description="dateErrorDescription"
            banner
            show-icon
            closable
            @close="showDateErrors = false"
          />
        </div>

        <div class="col-md-12 mt-2" v-if="showFormatError">
          <a-alert
            type="error"
            :message="$t('xlsxUploader.formatFichierInvalide')"
            :description="$t('xlsxUploader.formatFichierInvalideSubTitle')"
            banner
            show-icon
            closable
            @close="showFormatError = false"
          />
        </div>

        <div class="col-md-12 mt-2" v-if="showFaultyLinesError">
          <a-alert
            type="error"
            :message="$t('xlsxUploader.erreurValidationEleves')"
            :description="faultyLinesDescription"
            banner
            show-icon
            closable
            @close="showFaultyLinesError = false"
          />
        </div>

        <div class="col-md-12 mt-2" v-if="showPotentialExistsErrors">
          <a-alert
            type="info"
            :message="$t('xlsxUploader.elevesExistants')"
            :description="potentialExistsDescription"
            banner
            show-icon
            closable
            @close="showPotentialExistsErrors = false"
          />
        </div>

        <div class="col-md-12 mt-2">
          <a-divider></a-divider>

          <a-page-header
            :title="$t('xlsxUploader.verifierDonnees')"
            :sub-title="$t('xlsxUploader.affecterParents')"
          >
            <template slot="tags">
              <a-tag color="blue">
                {{ $t("xlsxUploader.sectionParent") }}
              </a-tag>
            </template>
            <a-descriptions size="small" :column="3">
              <a-descriptions-item :label="$t('xlsxUploader.totalEleves')">
                {{ studentsData.length }}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('xlsxUploader.totalParents')">
                {{ parentsData.length }}
              </a-descriptions-item>
              <a-descriptions-item
                :label="$t('xlsxUploader.elevesNonAffectes')"
              >
                {{ eleveNotAffacted }}
              </a-descriptions-item>
              <a-descriptions-item
                :label="$t('xlsxUploader.elevesExistantsPotentiels')"
              >
                {{ potentialExistsCount }}
              </a-descriptions-item>
              <a-descriptions-item
                :label="$t('xlsxUploader.elevesNonAffectes')"
              >
                <a-icon
                  type="warning"
                  theme="filled"
                  class="m-2"
                  :style="{ color: '#cc3300', fontSize: '26px' }"
                />
              </a-descriptions-item>
              <a-descriptions-item
                :label="$t('xlsxUploader.verificationParents')"
              >
                <a-icon
                  type="warning"
                  theme="filled"
                  class="m-2"
                  :style="{ color: '#ffcc00', fontSize: '26px' }"
                />
              </a-descriptions-item>
              <a-descriptions-item :label="$t('xlsxUploader.existeDeja')">
                <a-icon
                  type="warning"
                  theme="filled"
                  class="m-2"
                  :style="{ color: '#1890ff', fontSize: '26px' }"
                />
              </a-descriptions-item>
            </a-descriptions>
          </a-page-header>

          <!-- Filter and Selection Controls -->
          <div
            class="mb-3 p-3"
            style="
              background-color: #fafafa;
              border-radius: 4px;
              border: 1px solid #d9d9d9;
            "
          >
            <a-row type="flex" align="middle" :gutter="16">
              <a-col :xs="24" :md="16" :lg="18">
                <div style="margin-bottom: 12px">
                  <strong style="font-size: 14px; color: #262626">
                    <a-icon type="filter" style="margin-right: 6px" />
                    {{ $t("xlsxUploader.filtrerPar") }}
                  </strong>
                </div>

                <a-row :gutter="[12, 12]">
                  <a-col :xs="24" :sm="8">
                    <a-checkbox
                      v-model="activeFilters.red"
                      @change="handleFilterChange"
                      :disabled="selectionMode"
                    >
                      <a-icon
                        type="warning"
                        theme="filled"
                        :style="{
                          color: '#cc3300',
                          fontSize: '16px',
                          marginRight: '6px',
                        }"
                      />
                      <span>{{ $t("xlsxUploader.elevesNonAffectes") }}</span>
                      <a-badge
                        :count="studentsData.filter((s) => !s.parent).length"
                        :number-style="{ backgroundColor: '#cc3300' }"
                        style="margin-left: 6px"
                      />
                    </a-checkbox>
                  </a-col>
                  <a-col :xs="24" :sm="8">
                    <a-checkbox
                      v-model="activeFilters.yellow"
                      @change="handleFilterChange"
                      :disabled="selectionMode"
                    >
                      <a-icon
                        type="warning"
                        theme="filled"
                        :style="{
                          color: '#faad14',
                          fontSize: '16px',
                          marginRight: '6px',
                        }"
                      />
                      <span>{{ $t("xlsxUploader.verificationParents") }}</span>
                      <a-badge
                        :count="
                          studentsData.filter(
                            (s) => s.moreThanOneFatherMatched === 1
                          ).length
                        "
                        :number-style="{ backgroundColor: '#faad14' }"
                        style="margin-left: 6px"
                      />
                    </a-checkbox>
                  </a-col>
                  <a-col :xs="24" :sm="8">
                    <a-checkbox
                      v-model="activeFilters.blue"
                      @change="handleFilterChange"
                      :disabled="selectionMode"
                    >
                      <a-icon
                        type="warning"
                        theme="filled"
                        :style="{
                          color: '#1890ff',
                          fontSize: '16px',
                          marginRight: '6px',
                        }"
                      />
                      <span>{{ $t("xlsxUploader.existeDeja") }}</span>
                      <a-badge
                        :count="potentialExistsCount"
                        :number-style="{ backgroundColor: '#1890ff' }"
                        style="margin-left: 6px"
                      />
                    </a-checkbox>
                  </a-col>
                </a-row>
                <div
                  v-if="
                    activeFilters.red ||
                    activeFilters.yellow ||
                    activeFilters.blue
                  "
                  style="
                    margin-top: 12px;
                    padding-top: 12px;
                    border-top: 1px solid #e8e8e8;
                  "
                >
                  <a-button
                    size="small"
                    @click="clearFilters"
                    :disabled="selectionMode"
                  >
                    <a-icon type="close-circle" />
                    {{ $t("xlsxUploader.effacerFiltres") }}
                  </a-button>
                  <span
                    style="margin-left: 12px; color: #595959; font-size: 13px"
                  >
                    <a-icon
                      type="filter"
                      theme="filled"
                      style="color: #1890ff"
                    />
                    <strong style="margin-left: 4px">
                      {{ filteredStudentsCount }} / {{ studentsData.length }}
                    </strong>
                    {{ $t("xlsxUploader.totalEleves").toLowerCase() }}
                  </span>
                </div>
              </a-col>

              <!-- Actions Section -->
              <a-col :xs="24" :md="8" :lg="6">
                <div style="margin-bottom: 12px">
                  <strong style="font-size: 14px; color: #262626">
                    <a-icon type="control" style="margin-right: 6px" />
                    {{ $t("xlsxUploader.actions") }}
                  </strong>
                </div>

                <div v-if="!selectionMode">
                  <a-button @click="toggleSelectionMode" block>
                    <a-icon type="delete" />
                    {{ $t("xlsxUploader.retirerDeLaListe") }}
                  </a-button>
                </div>

                <div v-else>
                  <a-space direction="vertical" :size="8" style="width: 100%">
                    <a-button @click="cancelSelection" block>
                      <a-icon type="close" />
                      {{ $t("xlsxUploader.annuler") }}
                    </a-button>
                    <a-button
                      @click="confirmRemoval"
                      type="danger"
                      :disabled="selectedRowKeys.length === 0"
                      block
                    >
                      <a-icon type="delete" />
                      {{ $t("xlsxUploader.confirmerRetrait") }}
                      <a-badge
                        v-if="selectedRowKeys.length > 0"
                        :count="selectedRowKeys.length"
                        :number-style="{
                          backgroundColor: '#fff',
                          color: '#ff4d4f',
                        }"
                        style="margin-left: 6px"
                      />
                    </a-button>
                  </a-space>
                </div>
              </a-col>
            </a-row>
          </div>

          <!-- Selection Mode Info -->
          <div v-if="selectionMode" class="mb-3">
            <a-alert
              type="warning"
              :message="$t('xlsxUploader.modeSelection')"
              :description="$t('xlsxUploader.modeSelectionDescription')"
              show-icon
              closable
              @close="cancelSelection"
            />
          </div>

          <a-table
            :data-source="filteredStudentsData"
            :columns="columns"
            :loading="loading"
            :row-selection="rowSelection"
            :row-key="(record) => record.key"
            :pagination="{
              'show-size-changer': true,
            }"
          >
            <template slot="name" slot-scope="text, record">
              {{ record.firstName + (record.middleName ? " " + record.middleName : "") + " " + record.lastName }}
            </template>
            <template slot="key" slot-scope="text">
              {{ Number(text) + 1 }}
            </template>
            <template slot="gender" slot-scope="text">
              {{
                text === "male"
                  ? $t("xlsxUploader.garcon")
                  : $t("xlsxUploader.fille")
              }}
            </template>
            <template slot="BirthDate" slot-scope="text">
              <span v-if="!isDateValid(text)">
                <a-tag color="red">{{ text }}</a-tag>
              </span>
              <span v-else>
                {{ moment(text).format("DD-MM-YYYY") }}
              </span>
            </template>

            <div slot="indice" slot-scope="text, record">
              <a-tooltip v-if="record.potentialExists">
                <template slot="title">
                  {{ $t("xlsxUploader.existeDeja") }}
                  <span
                    v-if="
                      record.potentialMatches &&
                      record.potentialMatches.length > 0
                    "
                  >
                    <br />{{ $t("xlsxUploader.correspondances") }}:
                    {{ record.potentialMatches.length }}
                  </span>
                </template>
                <a-icon
                  type="warning"
                  theme="filled"
                  class="m-2"
                  :style="{ color: '#1890ff', fontSize: '22px' }"
                />
              </a-tooltip>

              <!-- Yellow Alert: Multiple Parent Matches -->
              <a-tooltip v-if="record.moreThanOneFatherMatched == 1">
                <template slot="title">
                  {{ $t("xlsxUploader.verificationParents") }}
                </template>
                <a-icon
                  type="warning"
                  theme="filled"
                  class="m-2"
                  :style="{ color: '#ffcc00', fontSize: '22px' }"
                />
              </a-tooltip>

              <!-- Red Alert: No Parent Assigned -->
              <a-tooltip v-if="record.moreThanOneFatherMatched == -1">
                <template slot="title">
                  {{ $t("xlsxUploader.eleveNonAffecte") }}
                </template>
                <a-icon
                  type="warning"
                  theme="filled"
                  class="m-2"
                  :style="{ color: '#cc3300', fontSize: '22px' }"
                />
              </a-tooltip>
            </div>
            <div slot="parent" slot-scope="text, record">
              <!-- <a-select
                show-search
                placeholder="Affecter un parent"
                style="width: 200px"
                @change="(value) => handleChange(value, record)"
                option-filter-prop="children"
                :filter-option="filterOption"
                :defaultValue="record.parent ? record.parent.key : undefined"
              >
                <a-select-option
                  v-for="parent in parentsData"
                  :key="parent.key"
                  :value="parent.key"
                >
                  {{
                    parent.father.firstName +
                    (parent.father.middleName ? " " + parent.father.middleName : "") +
                    " " +
                    parent.father.lastName
                  }}
                </a-select-option>
              </a-select>-->

              <multiselect
                :value="record.parent ? record.parent : undefined"
                @select="(value, id) => handleChange(value, record)"
                :placeholder="$t('xlsxUploader.affecterParent')"
                :selectLabel="$t('xlsxUploader.affecterParent')"
                :options="parentsData"
                :custom-label="parentMultiselectLabel"
                :close-on-select="true"
                :preserve-search="true"
                label="key"
                track-by="key"
                :preselect-first="false"
                :multiple="false"
              >
                <template slot="option" slot-scope="props">
                  <span>{{ parentMultiselectLabel(props.option) }}</span>
                </template>
                <template slot="singleLabel" slot-scope="props">
                  <span>{{ parentMultiselectLabel(props.option) }}</span>
                </template>
              </multiselect>
            </div>
            <div
              slot="filterDropdown"
              slot-scope="{
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
                column,
              }"
              style="padding: 8px"
            >
              <a-input
                v-ant-ref="(c) => (searchInput = c)"
                :placeholder="$t('paiement.chercher') + ` ${column.dataIndex}`"
                :value="selectedKeys[0]"
                style="width: 188px; margin-bottom: 8px; display: block"
                @change="
                  (e) => setSelectedKeys(e.target.value ? [e.target.value] : [])
                "
                @pressEnter="
                  () => handleSearch(selectedKeys, confirm, column.dataIndex)
                "
              />
              <a-button
                type="primary"
                icon="search"
                size="small"
                style="width: 90px; margin-right: 8px"
                @click="
                  () => handleSearch(selectedKeys, confirm, column.dataIndex)
                "
              >
                {{ $t("xlsxUploader.rechercher") }}
              </a-button>
              <a-button
                size="small"
                style="width: 90px"
                @click="() => handleReset(clearFilters)"
              >
                {{ $t("xlsxUploader.reset") }}
              </a-button>
            </div>
            <a-icon
              slot="filterIcon"
              slot-scope="filtered"
              type="search"
              :style="{ color: filtered ? '#108ee9' : undefined }"
            />
            <template
              slot="customRender"
              slot-scope="text, record, index, column"
            >
              <span v-if="searchText && searchedColumn === column.dataIndex">
                <template
                  v-for="(fragment, i) in text
                    .toString()
                    .split(
                      new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')
                    )"
                >
                  <mark
                    v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                    :key="i"
                    class="highlight"
                    >{{ fragment }}</mark
                  >
                  <template v-else>{{ fragment }}</template>
                </template>
              </span>
              <template v-else>
                {{ text }}
              </template>
            </template>
          </a-table>
        </div>
        <div class="col-md-12 mt-2">
          <a-button
            type="primary"
            style="width: 100%"
            :disabled="disableUploadBtn"
            :loading="disableUploadBtn"
            @click="addStudents"
          >
            <a-icon type="usergroup-add" />{{ $t("xlsxUploader.enregistrer") }}
          </a-button>
        </div>
      </div>

      <!-- Removal Confirmation Modal -->
      <a-modal
        v-model="showRemovalConfirmModal"
        :title="$t('xlsxUploader.confirmerRetraitTitle')"
        :ok-text="$t('xlsxUploader.confirmer')"
        :cancel-text="$t('xlsxUploader.annuler')"
        @ok="executeRemoval"
        @cancel="showRemovalConfirmModal = false"
      >
        <p>
          {{
            $t("xlsxUploader.confirmerRetraitMessage", {
              count: selectedRowKeys.length,
            })
          }}
        </p>
        <a-alert
          type="warning"
          :message="$t('xlsxUploader.actionIrreversible')"
          show-icon
        />
      </a-modal>

      <!-- Save Confirmation Modal -->
      <a-modal
        v-model="showSaveConfirmModal"
        :title="$t('xlsxUploader.confirmerEnregistrement')"
        :ok-text="$t('xlsxUploader.confirmer')"
        :cancel-text="$t('xlsxUploader.annuler')"
        :confirm-loading="disableUploadBtn"
        @ok="executeSave"
        @cancel="showSaveConfirmModal = false"
        width="600px"
      >
        <div style="margin-bottom: 16px">
          <h4 style="margin-bottom: 12px; color: #262626">
            <a-icon
              type="info-circle"
              style="color: #1890ff; margin-right: 8px"
            />
            {{ $t("xlsxUploader.resumeImportation") }}
          </h4>
          <p style="color: #595959; margin-bottom: 16px">
            {{ $t("xlsxUploader.confirmezVousEnregistrement") }}
          </p>
        </div>

        <a-descriptions bordered size="small" :column="1">
          <a-descriptions-item :label="$t('xlsxUploader.totalDansFichier')">
            <a-tag color="blue">
              <strong style="font-size: 14px">{{
                originalStudentCount
              }}</strong>
              {{ $t("xlsxUploader.eleves") }}
            </a-tag>
          </a-descriptions-item>

          <a-descriptions-item :label="$t('xlsxUploader.elevesAInserer')">
            <a-tag color="green">
              <strong style="font-size: 14px">{{ studentsData.length }}</strong>
              {{ $t("xlsxUploader.eleves") }}
            </a-tag>
          </a-descriptions-item>

          <a-descriptions-item
            v-if="
              studentsData.filter((s) => s.moreThanOneFatherMatched === 1)
                .length > 0
            "
            :label="$t('xlsxUploader.elevesAvecParentsSimilaires')"
          >
            <a-tag color="orange">
              <a-icon type="warning" theme="filled" />
              <strong style="font-size: 14px; margin-left: 4px">
                {{
                  studentsData.filter((s) => s.moreThanOneFatherMatched === 1)
                    .length
                }}
              </strong>
              {{ $t("xlsxUploader.eleves") }}
            </a-tag>
          </a-descriptions-item>

          <a-descriptions-item
            v-if="potentialExistsCount > 0"
            :label="$t('xlsxUploader.elevesExistantsPotentiels')"
          >
            <a-tag color="blue">
              <a-icon type="warning" theme="filled" />
              <strong style="font-size: 14px; margin-left: 4px">
                {{ potentialExistsCount }}
              </strong>
              {{ $t("xlsxUploader.eleves") }}
            </a-tag>
          </a-descriptions-item>

          <a-descriptions-item
            v-if="removedCount > 0"
            :label="$t('xlsxUploader.elevesRetiresDeListe')"
          >
            <a-tag color="red">
              <a-icon type="delete" />
              <strong style="font-size: 14px; margin-left: 4px">
                {{ removedCount }}
              </strong>
              {{ $t("xlsxUploader.eleves") }}
            </a-tag>
          </a-descriptions-item>
        </a-descriptions>

        <div
          v-if="
            potentialExistsCount > 0 ||
            studentsData.filter((s) => s.moreThanOneFatherMatched === 1)
              .length > 0
          "
          style="margin-top: 16px"
        >
          <a-alert
            type="warning"
            show-icon
            :message="$t('xlsxUploader.verifierAvantImport')"
          />
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import apiClient from "@/services/axios";
import * as XLSX from "xlsx/xlsx.mjs";
/* load 'fs' for readFile and writeFile support */
import moment from "moment";
import { mapState } from "vuex";
import router from "@/router";
import { isKenyanSchool } from "@/utilities/countrySpecific";
import { normalizePhone } from "@/utilities/phone";

const validInput = (item) => {
  if (
    !item.BirthDate ||
    !isNaN(new Date(item.BirthDate)) ||
    !["male", "female"].includes(item.gender)
  )
    return false;
  return true;
};

export default {
  computed: {
    ...mapState(["settings"]),
    isKenyan() {
      return isKenyanSchool();
    },
    filteredStudentsData() {
      // Check if any filter is active
      const hasActiveFilters =
        this.activeFilters.red ||
        this.activeFilters.yellow ||
        this.activeFilters.blue;

      // If no filters active, return all data
      if (!hasActiveFilters) {
        return this.studentsData;
      }

      // Filter students based on active filters
      return this.studentsData.filter((student) => {
        const isRed = !student.parent; // No parent assigned
        const isYellow = student.moreThanOneFatherMatched === 1; // Multiple parent matches
        const isBlue = student.potentialExists === true; // Potentially exists

        // Return true if student matches any active filter
        return (
          (this.activeFilters.red && isRed) ||
          (this.activeFilters.yellow && isYellow) ||
          (this.activeFilters.blue && isBlue)
        );
      });
    },
    filteredStudentsCount() {
      return this.filteredStudentsData.length;
    },
    rowSelection() {
      if (!this.selectionMode) {
        return null;
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        onSelectAll: this.onSelectAll,
      };
    },
    columns() {
      return [
        {
          title: "",
          dataIndex: "key",
          key: "key",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "key",
          },
          onFilter: (value, record) =>
            record.key.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          },
        },
        {
          title: this.$t("xlsxUploader.nomPrenom"),
          dataIndex: "firstName",
          key: "name",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "name",
          },
          onFilter: (value, record) => {
            const v = value.toLowerCase();
            const mid = (record.middleName || "").toString().toLowerCase();
            return (
              (record.firstName || "").toString().toLowerCase().includes(v) ||
              (record.lastName || "").toString().toLowerCase().includes(v) ||
              mid.includes(v)
            );
          },
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          },
        },
        {
          title: this.$t("xlsxUploader.dateNaissance"),
          dataIndex: "BirthDate",
          key: "BirthDate",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "BirthDate",
          },
          onFilter: (value, record) =>
            record.BirthDate.toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("xlsxUploader.adresse"),
          dataIndex: "adress",
          key: "adress",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "customRender",
          },
          onFilter: (value, record) =>
            record.adress
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("xlsxUploader.sexe"),
          dataIndex: "gender",
          key: "gender",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "gender",
          },
          onFilter: (value, record) =>
            record.gender
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("xlsxUploader.telephone"),
          dataIndex: "phone",
          key: "phone",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "customRender",
          },
          onFilter: (value, record) =>
            record.phone.toString().toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.isKenyan ? this.$t("profil.nemisNumber") : this.$t("xlsxUploader.identifiantUnique"),
          dataIndex: "uniqueId",
          key: "uniqueId",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "customRender",
          },
          onFilter: (value, record) =>
            record.uniqueId
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("xlsxUploader.parent"),
          dataIndex: "parent",
          key: "parent",
          scopedSlots: {
            customRender: "parent",
          },
        },
        {
          title: "",
          dataIndex: "parent",
          key: "indice",
          scopedSlots: {
            customRender: "indice",
          },
        },
      ];
    },
  },
  data() {
    return {
      fileList: [],
      xlsxFile: null,
      searchText: "",
      searchInput: null,
      searchedColumn: "",
      studentsData: [],
      parentsData: [],
      loading: false,
      eleveNotAffacted: 0,
      disableUploadBtn: false,
      step: 0,
      error: {
        parent: 0,
        student: 0,
      },
      // Variables pour les alertes persistantes
      showStudentErrors: false,
      showParentErrors: false,
      showDateErrors: false,
      showFormatError: false,
      showFaultyLinesError: false,
      showPotentialExistsErrors: false,
      studentErrorDescription: "",
      parentErrorDescription: "",
      dateErrorDescription: "",
      faultyLinesDescription: "",
      potentialExistsDescription: "",
      potentialExistsCount: 0,
      // Filters for alert types
      activeFilters: {
        red: false,
        yellow: false,
        blue: false,
      },
      // Selection mode for removal
      selectionMode: false,
      selectedRowKeys: [],
      selectedRows: [],
      removedCount: 0,
      showRemovalConfirmModal: false,
      // Save confirmation modal
      showSaveConfirmModal: false,
      originalStudentCount: 0,
    };
  },
  methods: {
    moment,
    getCorrectedDate(date) {
      function getTimezoneOffsetMS(date) {
        var fullYear = date.getFullYear();
        var month = date.getMonth();
        var day = date.getDate();
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var seconds = date.getSeconds();
        var ms = date.getMilliseconds();

        var time = date.getTime();
        var utcTime = Date.UTC(
          fullYear,
          month,
          day,
          hours,
          minutes,
          seconds,
          ms
        );
        var result = time - utcTime;
        return result;
      }
      return new Date(date.getTime() - getTimezoneOffsetMS(date));
    },
    /** Used for search + option/singleLabel slots (vue-multiselect needs slots for reliable display). */
    parentMultiselectLabel(option) {
      const father = option?.father;
      if (!father) return "";
      return [father.lastName, father.middleName, father.firstName]
        .map((x) =>
          x != null && String(x).trim() !== "" ? String(x).trim() : null
        )
        .filter(Boolean)
        .join(" ");
    },
    handleChange(value, record) {
      record.parent = this.parentsData.find((e) => e.key === value.key);
      this.eleveNotAffacted = this.studentsData.filter((e) => !e.parent).length;
      this.eleveNotAffacted === 0 ? (this.step = 2) : (this.step = 1);
      record.moreThanOneFatherMatched = 0;

      // Update alert descriptions if needed
      this.updateAlertDescriptions();
    },
    handleFilterChange() {
      // Force re-computation of filtered data
      // The computed property will automatically update
    },
    clearFilters() {
      this.activeFilters.red = false;
      this.activeFilters.yellow = false;
      this.activeFilters.blue = false;
    },
    toggleSelectionMode() {
      this.selectionMode = true;
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },
    cancelSelection() {
      this.selectionMode = false;
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    onSelectAll(selected, selectedRows, changeRows) {
      if (selected) {
        // Select all visible (filtered) rows
        this.selectedRowKeys = this.filteredStudentsData.map((s) => s.key);
        this.selectedRows = [...this.filteredStudentsData];
      } else {
        // Deselect all
        this.selectedRowKeys = [];
        this.selectedRows = [];
      }
    },
    confirmRemoval() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning(this.$t("xlsxUploader.selectionnerAuMoinsUn"));
        return;
      }
      this.showRemovalConfirmModal = true;
    },
    executeRemoval() {
      const keysToRemove = new Set(this.selectedRowKeys);

      // Remove selected students from the list
      this.studentsData = this.studentsData.filter(
        (student) => !keysToRemove.has(student.key)
      );

      // Update removed count
      this.removedCount += this.selectedRowKeys.length;

      // Update all alert descriptions and counts
      this.updateAlertDescriptions();

      // Show success message
      this.$message.success(
        this.$t("xlsxUploader.elevesRetires", {
          count: this.selectedRowKeys.length,
        })
      );

      // Exit selection mode
      this.cancelSelection();
      this.showRemovalConfirmModal = false;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    addTofileList() {
      this.fileList = [this.xlsxFile];
    },
    beforeUpload(file) {
      this.loading = true;
      const isExcel = file.type.includes("sheet");
      if (!isExcel) {
        this.$message.error(this.$t("xlsxUploader.formatFichierInvalide"));
      }
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.error(
          this.$t("xlsxUploader.formatFichierInvalideSubTitle")
        );
      }
      if (isExcel && isLt2M) {
        this.$message.success(
          this.$t("xlsxUploader.formatFichierInvalideSubTitle")
        );
        this.xlsxFile = file;
        this.step = 1;
        this.handleFilesUpload();
      }
      return isExcel && isLt2M;
    },
    async handleFilesUpload() {
      this.error.student = 0;
      this.error.parent = 0;
      let faultyLines = [];

      // Réinitialiser toutes les alertes
      this.resetAlerts();

      try {
        let f = this.xlsxFile;
        //let reader = new FileReader();
        let studentsJson = [];
        const ab = await f.arrayBuffer();
        //let data = e.target.result;
        let workbook = XLSX.read(ab, {
          type: "binary",
          cellDates: true,
          cellNF: false,
        });

        // Define column mappings
        const columns = {
          student: {
            firstName: this.isKenyan ? "First Name" : "Prénom",
            middleName: this.isKenyan ? "Middle Name" : "Deuxième prénom",
            lastName: this.isKenyan ? "Last Name" : "Nom",
            address: this.isKenyan ? "Address" : "Adresse",
            birthDate: this.isKenyan ? "Date of Birth" : "Date de naissance",
            uniqueId: this.isKenyan ? "Student NEMIS Number" : "Identifiant unique",
            gender: this.isKenyan ? "Gender" : "Sexe",
            phone: this.isKenyan ? "Phone" : "Téléphone",
          },
          parent: {
            fatherFirstName: this.isKenyan ? "Father's First Name" : "Prénom pére",
            fatherMiddleName: this.isKenyan
              ? "Father's Middle Name"
              : "Deuxième prénom père",
            fatherLastName: this.isKenyan ? "Father's Last Name" : "Nom pére",
            fatherPhone: this.isKenyan ? "Father's Phone" : "Téléphone père",
            fatherJob: this.isKenyan ? "Father's Job" : "Fonction père",
            fatherAddress: this.isKenyan ? "Father's Address" : "Adresse père",
            fatherEmail: this.isKenyan ? "Father's Email" : "email père",
            motherFirstName: this.isKenyan ? "Mother's First Name" : "Prénom mère",
            motherMiddleName: this.isKenyan
              ? "Mother's Middle Name"
              : "Deuxième prénom mère",
            motherLastName: this.isKenyan ? "Mother's Last Name" : "Nom mère",
            motherPhone: this.isKenyan ? "Mother's Phone" : "Téléphone mère",
            motherJob: this.isKenyan ? "Mother's Job" : "Fonction mère",
            motherAddress: this.isKenyan ? "Mother's Address" : "Adresse mère",
            motherEmail: this.isKenyan ? "Mother's Email" : "email mère",
          },
        };

        // Get worksheet parents
        let worksheetParent = workbook.Sheets[workbook.SheetNames[1]];
        let parentsJson = XLSX.utils.sheet_to_json(worksheetParent);
        let activeBuilding = this.settings.activeBuilding;
        parentsJson = parentsJson.map((elem, index) => {
          this.parentValidation(elem, columns.parent);
          const trimCell = (colKey) => {
            const v = elem[columns.parent[colKey]];
            if (v == null || String(v).trim() === "") return "";
            return String(v).trim();
          };
          let parent = {
            key: index,
            father: {
              firstName: elem[columns.parent.fatherFirstName],
              middleName: trimCell("fatherMiddleName"),
              lastName: elem[columns.parent.fatherLastName],
              phone: normalizePhone(elem[columns.parent.fatherPhone]),
              job: elem[columns.parent.fatherJob],
              adress: elem[columns.parent.fatherAddress],
              email: elem[columns.parent.fatherEmail],
            },
            mother: {
              firstName: elem[columns.parent.motherFirstName],
              middleName: trimCell("motherMiddleName"),
              lastName: elem[columns.parent.motherLastName],
              phone: normalizePhone(elem[columns.parent.motherPhone]),
              job: elem[columns.parent.motherJob],
              adress: elem[columns.parent.motherAddress],
              email: elem[columns.parent.motherEmail],
            },
            buildingDB: activeBuilding,
          };
          return parent;
        });
        this.parentsData = parentsJson;
        // Get worksheet student
        let worksheetStudent = workbook.Sheets[workbook.SheetNames[0]];

        studentsJson = XLSX.utils.sheet_to_json(worksheetStudent);
        studentsJson = studentsJson.map((elem, index) => {
          this.studetnValidation(elem, columns.student);
          let matchFather = this.parentsData.filter((item) =>
            (item.father?.lastName?.toLowerCase() || "").includes(
              elem[columns.student.lastName].toLowerCase()
            )
          );

          const rawMiddle = elem[columns.student.middleName];
          const middleName =
            rawMiddle != null && String(rawMiddle).trim() !== ""
              ? String(rawMiddle).trim()
              : "";

          let student = {
            key: index,
            firstName: elem[columns.student.firstName],
            middleName,
            lastName: elem[columns.student.lastName],
            adress: elem[columns.student.address],
            BirthDate: elem[columns.student.birthDate],
            uniqueId: elem[columns.student.uniqueId],
            gender:
              elem[columns.student.gender] == "F" || elem[columns.student.gender] == "f" || elem[columns.student.gender] == "Female" ? "female" : "male",
            phone: normalizePhone(elem[columns.student.phone]),
            schoolarYearsHistory: {},
            parent: matchFather[0],
            moreThanOneFatherMatched:
              matchFather.length === 0 ? -1 : matchFather.length > 1 ? 1 : 0,
          };
          student.schoolarYearsHistory[this.settings.activeSchoolarYear] = null;

          return student;
        });

        this.studentsData = studentsJson;

        this.originalStudentCount = studentsJson.length;
        this.removedCount = 0;

        let i = 2;
        this.studentsData = this.studentsData.map((item) => {
          if (validInput(item)) faultyLines.push(i);
          try {
            this.getCorrectedDate(item.BirthDate);
          } catch (error) {
            return item;
          } finally {
            i += 1;
          }
          return {
            ...item,
            BirthDate: this.getCorrectedDate(new Date(item.BirthDate)),
          };
        });
        this.eleveNotAffacted = this.studentsData.filter(
          (e) => !e.parent
        ).length;
        this.eleveNotAffacted === 0 ? (this.step = 2) : (this.step = 1);

        // Check for potentially existing students
        await this.checkPotentialExistingStudents();

        this.loading = false;
      } catch (error) {
        console.error(error);
        this.showFormatError = true;
        this.loading = false;
      }
      if (faultyLines.length > 0) {
        this.showFaultyLinesError = true;
        this.faultyLinesDescription = `${this.$t(
          "xlsxUploader.verifierDonnees"
        )} ${
          faultyLines.length == 1
            ? this.$t("xlsxUploader.laLigne") + faultyLines[0]
            : this.$t("xlsxUploader.lesLignes") +
              "".concat(faultyLines.map((i) => `\n - ${i}`))
        } , ${this.$t("xlsxUploader.dansLeFichierExcel")}`;
      }
    },
    studetnValidation(elem, columns) {
      if (
        !elem[columns.firstName] ||
        !elem[columns.lastName] ||
        !elem[columns.birthDate] ||
        !elem[columns.gender]
      ) {
        console.log("studetnValidation error :", elem, elem.__rowNum__);
        this.error.student += 1;
        this.showStudentErrors = true;
        this.studentErrorDescription =
          (this.studentErrorDescription || "") +
          `${this.$t("xlsxUploader.verifierDonnees")} ${
            elem.__rowNum__ + 1
          } , ${this.$t("xlsxUploader.dansLeFichierExcel")}\n`;
      }
      if (!this.isDateValid(elem[columns.birthDate])) {
        this.error.student += 1;
        this.showDateErrors = true;
        this.dateErrorDescription =
          (this.dateErrorDescription || "") +
          `${this.$t("xlsxUploader.verifierDonnees")} ${
            elem.__rowNum__ + 1
          } , ${elem[columns.birthDate]} ${this.$t(
            "xlsxUploader.dansLeFichierExcel"
          )}\n`;
      }
    },
    parentValidation(elem, columns) {
      if (
        !elem[columns.fatherFirstName] ||
        !elem[columns.fatherLastName] ||
        !elem[columns.fatherPhone] ||
        !elem[columns.motherFirstName] ||
        !elem[columns.motherLastName] ||
        !elem[columns.motherPhone]
      ) {
        this.error.parent += 1;
        this.showParentErrors = true;
        this.parentErrorDescription =
          (this.parentErrorDescription || "") +
          `${this.$t("xlsxUploader.verifierDonnees")} ${
            elem.__rowNum__ + 1
          } , ${this.$t("xlsxUploader.dansLeFichierExcel")}\n`;
      }
    },
    resetAlerts() {
      this.showStudentErrors = false;
      this.showParentErrors = false;
      this.showDateErrors = false;
      this.showFormatError = false;
      this.showFaultyLinesError = false;
      this.showPotentialExistsErrors = false;
      this.studentErrorDescription = "";
      this.parentErrorDescription = "";
      this.dateErrorDescription = "";
      this.faultyLinesDescription = "";
      this.potentialExistsDescription = "";
      this.potentialExistsCount = 0;
    },
    updateAlertDescriptions() {
      // Update blue alert (potentially existing students)
      this.potentialExistsCount = this.studentsData.filter(
        (s) => s.potentialExists
      ).length;

      if (this.potentialExistsCount > 0) {
        this.showPotentialExistsErrors = true;
        this.potentialExistsDescription = `${this.potentialExistsCount} ${
          this.potentialExistsCount === 1
            ? this.$t("xlsxUploader.eleveExisteDeja")
            : this.$t("xlsxUploader.elevesExistentDeja")
        }. ${this.$t("xlsxUploader.verifierAvantImport")}`;
      } else {
        this.showPotentialExistsErrors = false;
        this.potentialExistsDescription = "";
      }

      // Update red alert count (students without parents)
      this.eleveNotAffacted = this.studentsData.filter((e) => !e.parent).length;
    },
    async checkPotentialExistingStudents() {
      try {
        // Build request payload
        const studentsToCheck = this.studentsData.map((student) => ({
          firstName: student.firstName,
          middleName: student.middleName || "",
          lastName: student.lastName,
          uniqueId: student.uniqueId,
        }));

        // Call the API
        const response = await apiClient.post("/students/check-existing", {
          students: studentsToCheck,
        });

        // Merge results back into studentsData
        if (response.data && response.data.results) {
          response.data.results.forEach((result) => {
            const student = this.studentsData[result.index];
            if (student) {
              student.potentialExists = result.exists;
              student.potentialMatches = result.potentialMatches || [];
            }
          });

          // Count students with potential matches
          this.potentialExistsCount = this.studentsData.filter(
            (s) => s.potentialExists
          ).length;

          // Show blue alert if there are potential duplicates
          if (this.potentialExistsCount > 0) {
            this.showPotentialExistsErrors = true;

            this.potentialExistsDescription = `${this.potentialExistsCount} ${
              this.potentialExistsCount === 1
                ? this.$t("xlsxUploader.eleveExisteDeja")
                : this.$t("xlsxUploader.elevesExistentDeja")
            }. ${this.$t("xlsxUploader.verifierAvantImport")}`;
          }
        }
      } catch (error) {
        console.error("Error checking existing students:", error);
        // Show a generic warning but don't block the workflow
        this.showPotentialExistsErrors = true;
        this.potentialExistsDescription = this.$t(
          "xlsxUploader.erreurVerificationExistence"
        );
      }
    },
    isDateValid(date) {
      if (typeof date === "string") {
        return moment(date, "DD-MM-YYYY", true).isValid();
      } else {
        return moment(date).isValid();
      }
    },
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
    },

    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    },
    download() {
      const { isKenyanSchool } = require("@/utilities/countrySpecific");
      const templateName = isKenyanSchool() ? "template_en.xlsx" : "template.xlsx";
      const url = `resources/${templateName}`;
      window.location.href = url;
    },
    addStudents(e) {
      // Validation checks
      if (this.error.student > 0) {
        this.showStudentErrors = true;
        if (!this.studentErrorDescription) {
          this.studentErrorDescription = this.$t(
            "xlsxUploader.verifierDonnees"
          );
          this.$message.warning(this.$t("xlsxUploader.verifierDonnees"));
        }
        return;
      } else if (this.error.parent > 0) {
        this.showParentErrors = true;
        if (!this.parentErrorDescription) {
          this.parentErrorDescription = this.$t("xlsxUploader.verifierDonnees");
          this.$message.warning(this.$t("xlsxUploader.verifierDonnees"));
        }
        return;
      }
      if (this.studentsData.filter((e) => !e.parent).length > 0) {
        this.showFaultyLinesError = true;
        this.faultyLinesDescription =
          "Veillez affecter un parent à chaque élève";
        this.$message.warning("Veillez affecter un parent a chaque élèves ");
        return;
      }

      this.showSaveConfirmModal = true;
    },
    async executeSave() {
      this.disableUploadBtn = true;

      try {
        const response = await apiClient.put("/students/importer", {
          students: this.studentsData,
        });
        if (response.data.failed) {
          this.$message.error(this.$t("xlsxUploader.verifierDonnees"));
          this.showSaveConfirmModal = false;
          return;
        }
        this.$message.success(this.$t("xlsxUploader.listeImporteeSucces"));
        this.showSaveConfirmModal = false;
        router.push(`/elevesliste`).catch(() => {
          // do nothing
          return;
        });
      } catch (error) {
        this.showFormatError = true;
        this.faultyLinesDescription = this.$t("xlsxUploader.verifierDonnees");
        this.$message.warning(this.$t("xlsxUploader.verifierDonnees"));
        this.showSaveConfirmModal = false;
      } finally {
        this.disableUploadBtn = false;
      }
    },
  },
};
</script>
